import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchCashFlow } from '@apis/fundamentals';
import type { CashFlowApiData } from '@app-types/performanceTrendsApi';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

/**
 * React Query hook for the Cash Flow section
 * (GET /api/fundamentals/cash-flow). Reads ticker/mkt from the router location
 * so URL changes refetch; stays disabled until a token is available.
 */
export const useCashFlow = () => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);
  const hasToken = Boolean(getAccessToken());

  return useQuery<CashFlowApiData>({
    queryKey: ['fundamentals', 'cash-flow', ticker, mkt],
    queryFn: () => fetchCashFlow({ ticker: ticker as string, mkt: mkt as string }),
    enabled: Boolean(ticker && mkt && hasToken),
    staleTime: 60_000,
    retry: 1,
  });
};
